import { of, pipe } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { State } from '../services/work.state';

export const noNavBack = () =>
  pipe(
    switchMap(([state, currentState]: [Partial<State>, State]) => {
      if (!state.system?.noNavBack)
        return of([state, currentState] as [Partial<State>, State]);

      const newState = {
        ...state,
        ...{
          noNavBack: state.system?.noNavBack,
          system: {
            ...state.system,
            ...{
              noNavBack: undefined,
            },
          },
        },
      };
      return of([newState, currentState] as [Partial<State>, State]);
    })
  );
